"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFundingFee = void 0;
const react_1 = require("react");
const SimpleFuturesAPI_1 = require("../../../apis/SimpleFuturesAPI");
/** 资金费列表 */
const useFundingFee = (orderId) => {
    const [fundingFee, setFundingFee] = (0, react_1.useState)();
    const [isEndOfPage, setIsEndOfPage] = (0, react_1.useState)(false);
    const [isPageDataFetching, setIsPageDataFetching] = (0, react_1.useState)(false);
    const [isRefreshing, setIsRefreshing] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const innerState = (0, react_1.useRef)({});
    // 请求开始
    const loadStart = (forceRefresh, withoutLoading) => {
        if (!withoutLoading) {
            if (forceRefresh) {
                setIsRefreshing(true);
            }
            else {
                setIsPageDataFetching(true);
            }
        }
        if (forceRefresh) {
            // 强制刷新，就清空分页数据
            innerState.current.nextPageToken = undefined;
        }
        setError(undefined);
        innerState.current.isFetching = true;
    };
    // 请求结束
    const loadEnd = (forceRefresh, withoutLoading) => {
        if (!withoutLoading) {
            if (forceRefresh) {
                setIsRefreshing(false);
            }
            else {
                setIsPageDataFetching(false);
            }
        }
        innerState.current.isFetching = false;
    };
    // 清空所有状态
    const clear = (0, react_1.useCallback)(() => {
        innerState.current = {};
        setIsRefreshing(false);
        setIsPageDataFetching(false);
        setIsEndOfPage(false);
        setFundingFee(undefined);
        setError(undefined);
    }, []);
    const triggerGetNextPageData = (0, react_1.useCallback)((forceRefresh, withoutLoading) => {
        // 正在请求中，直接返回
        if (innerState.current.isFetching) {
            return;
        }
        // 加载下一页，但是没有更多数据了，直接返回
        if (!forceRefresh && innerState.current.isEndOfPage) {
            return;
        }
        loadStart(forceRefresh, withoutLoading);
        SimpleFuturesAPI_1.SimpleFuturesAPI.getFundingFee({
            page_token: innerState.current.nextPageToken,
            bu_order_id: orderId,
        }).subscribe({
            next: (res) => {
                const hasNextPage = Boolean(res.next_page_token);
                setIsEndOfPage(!hasNextPage);
                innerState.current.isEndOfPage = !hasNextPage;
                innerState.current.nextPageToken = res.next_page_token;
                const newData = res.results || [];
                if (forceRefresh) {
                    setFundingFee(newData);
                }
                else {
                    setFundingFee((histories = []) => histories === null || histories === void 0 ? void 0 : histories.concat(newData));
                }
                setError(undefined);
                loadEnd(forceRefresh, withoutLoading);
            },
            error: (err) => {
                setError(err);
                setIsEndOfPage(true);
                innerState.current.isEndOfPage = true;
                loadEnd(forceRefresh, withoutLoading);
            },
        });
    }, [orderId]);
    const refreshPageData = (0, react_1.useCallback)(() => {
        triggerGetNextPageData(true);
    }, [triggerGetNextPageData]);
    return {
        fundingFee,
        clear,
        error,
        triggerGetNextPageData,
        refreshPageData,
        isEndOfPage,
        isPageDataFetching,
        isRefreshing,
    };
};
exports.useFundingFee = useFundingFee;
